import { render, staticRenderFns } from "./selectPlainText.vue?vue&type=template&id=09c1727b&"
import script from "./selectPlainText.vue?vue&type=script&lang=ts&"
export * from "./selectPlainText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports